module.exports = "https://web-assets.ifttt.com/packs/media/partners/sample_service_on_color_large-52108e26.png";